
  import React from "react"
  import Component from "/home/cseignant/work/repo/maya/dev/src/layouts/index.js"
  import data from "/home/cseignant/work/repo/maya/dev/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js